import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useClient } from '../../client-api';
import { type SettingsUpdateDto, updateExternalSettings, type UpdateSettingsResponseDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useUpdateProjectionExternalAssetSetting = (): UseMutationResult<UpdateSettingsResponseDto, AxiosError, SettingsUpdateDto> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (payload) => updateExternalSettings({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.saeExternalAssetSettings(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.projection(client?.partnerUuid) });
        },
    });
};
